// HMR does not use SSR'd entrypoint, so stub in globals here

import { createLogger } from '@graphistry/common/logger';
const logger = createLogger(__filename);

const configureHMR = process.env.STUB_DEPENDENCIES
    ? (glbl, options) => {
        console.log('@configureHMR dev');
        setGlobals(glbl, options);
        return options;
    }
    : (glbl, options) => options;


//Non-SSR alternative to server/startup/template.js::body()
function setGlobals(glbl, options) {
    const glbls = process.env.STUB_DEPENDENCIES
        ? {
            graphistryPath: process.env.BASE_PATH,  // app backend server: scripts/config/env.js => localhost:8080
            graphistryClientId: options.client || '-1',  // TODO: generalize for user testing
            graphistrySessionId: options.session,
            __INITIAL_CACHE__: { // TODO: generalize for user testing
                "workbooks": {
                    "0": {
                        "$type": "ref",
                        "value": ["workbooksById", options.session || options.dataset || "wb123" ]
                    },
                    "title": "",
                    "length": 1,
                    "open": {
                        "$type": "ref",
                        "value": ["workbooksById", options.session || options.dataset || "wb123" ]
                    }
                },
                'currentUser': {
                    "$type": "ref",
                    "value": ['usersById', options.client || '-1']
                },
                'usersById': {
                    [options.client || '-1']: {
                        email: 'user@email.com',
                        username: 'myusername', //FIXME currently email
                        userId: options.client || '-1',
                        //jwtToken: req.user.jwtToken,
                        csrfToken: 'mycsrfToken',
                        csrfmiddlewaretoken: 'mycsrfmiddlewaretoken',
                        isStaff: true,
                        isSuperUser: true,
                        flags: {
                            //TODO get
                        },
                        entitlements: {
                            GRAPHISTRY_CLOUD: [1, '1', 'true', 'TRUE'].indexOf(process.env.GRAPHISTRY_CLOUD) > -1
                        }
                    }
                },
                flags: {
                    //TODO get
                }
            }
        }
        : {
            //FIXME: Return actual SSR values
            graphistryPath: process.env.BASE_PATH,
            graphistryClientId: options.client,
            graphistrySessionId: options.session,
            __INITIAL_CACHE__ : {
                "workbooks": {
                    "0": {
                        "$type": "ref",
                        "value": ["workbooksById", options.session ]
                    },
                    "title": "",
                    "length": 1,
                    "open": {
                        "$type": "ref",
                        "value": ["workbooksById", options.session ]
                    }
                },
                'currentUser': {
                    "$type": "ref",
                    "value": ['usersById', options.client || '-1']
                },
                'usersById': {
                    [options.client || '-1']: {
                        email: 'user@email.com',
                        username: 'myusername', //FIXME currently email
                        userId: options.client || '-1',
                        //jwtToken: req.user.jwtToken,
                        csrfToken: 'mycsrfToken',
                        csrfmiddlewaretoken: 'mycsrfmiddlewaretoken',
                        isStaff: true,
                        isSuperUser: true,
                        isAuthenticated: true,
                        flags: {
                            //TODO get
                        },
                        entitlements: {
                            GRAPHISTRY_CLOUD: [1, '1', 'true', 'TRUE'].indexOf(process.env.GRAPHISTRY_CLOUD) > -1
                        }
                    }
                },
                'flags':  {
                    //TODO get...
                }
            }
        };

    for (const fld in glbls) {
        glbl[fld] = glbls[fld];
    }
    if (!glbl.graphistrySessionId) {
        console.log('No "session=..." set in url');
    }
    console.log('globals', {out: glbl, using: glbls}, );
}

function hmrRenderLoop(renderApp, getRootDOMNode) {
    const reRenderApp = () => {
        try {
            renderApp();
        } catch (error) {
            ReactDOM.render(<div><h1>Error</h1>{error}</div>, getRootDOMNode());
        }
    };
    module.hot.accept(['@graphistry/viz/src/containers/appStub'], () => {
        console.log('hot accept!');
        // App = withLegacyInterop(require('@graphistry/viz/src/containers/app').default); // eslint-disable-line global-require
        setImmediate(() => {
            // Preventing the hot reloading error from react-router
            // unmountComponentAtNode(getRootDOMNode());
            reRenderApp();
        });
    });
}

export { configureHMR, hmrRenderLoop };
export default configureHMR;
